import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  canal: any;
  canales: any[];
  canalInicial: any;
  
  constructor(
    private router: Router,
    private storage: Storage,
    private authService: AuthService
    ){}


    async canActivate(){

      const logged =  await this.storage.get('usuario');
  
  
      if(logged != null){
    //      this.canal = await this.storage.get('canal').then();
    // this.canales = await this.storage.get('canales').then();
    // // console.log(this.canales, 'canales ');
    // this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
    

    // this.authService.validarSesion(this.canalInicial.canale.idAdmin_sec, this.canalInicial.id, this.canalInicial.rol, this.canalInicial.token, this.canalInicial.canale.url_back).subscribe(
    //   (res: any) => {  // Usa `any` o define un tipo explícito
    //     console.log(res);
    //     if (res.status== "success") {
    //       return true
    //     } else  {
    //       this.router.navigateByUrl('/login');
    //       return false;
    //     }
    //   },
    //   error => {
    //     console.error(error);
    //     this.router.navigateByUrl('/login');
    //     return false;
    //   }
    // );
       return true;
      }
      if(!logged){
        this.router.navigateByUrl('/login');
      }
      else{
      this.router.navigateByUrl('/login');
      }
    }
  
}
